import { Icon } from "@synergy/icons";
import { Badge, Drawer, Space } from "antd";
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import Theme from "../../../../styles/Theme/Theme";
import { base64ToBytes } from "../../../../utils/hooks/base64ToBytes";
import { getColorBySeverity } from "../../../../utils/hooks/getColorByPriority";
import { isEmpty } from "../../../../utils/hooks/isEmpty";
import { isLogItem } from "../../../../utils/hooks/logItems";
import { RegisterDetailClusterView } from "../../../Pages/RegisterDetailClusterView";
import { RegisterDetailView } from "../../../Pages/RegisterDetailView";

const DrawerContainer = styled.div`
  position: relative;
  width: 100%;

  .drawerStyle {
    position: absolute;
    top: 88px;
    height: -webkit-fill-available;
    right: 0;
  }
`;



const MapDrawer = ({ selectedPOI, selectedCluster, onCloseDrawer, openDrawer, selectedLayer, handle3DView, setSelectedPOI }) => {
    const { t } = useTranslation();
    const [createIncidentModal, setCreateIncidentModal] = useState(false);

    return (
        <>
            <DrawerContainer id="drawer-container">
                <Drawer
                    title={selectedPOI ?
                        <Badge.Ribbon text={t("input.confidential")} color='red' style={{ display: selectedPOI?.confidential === "true" ? true : 'none' }}>
                            <Space>
                                <Icon icon={isLogItem(selectedPOI) ? 'Information' : selectedPOI.class} color="white"
                                    bgColor={isLogItem(selectedPOI) ? Theme.color["log-item"] : getColorBySeverity(selectedPOI.severity)}
                                    strokeWidth='1' iconsize='md' bgPadding='4px' />
                                {selectedPOI.name} {selectedPOI.title && `-`}
                                {selectedPOI.title && `${base64ToBytes(selectedPOI.title)}`}
                            </Space>
                        </Badge.Ribbon>
                        : selectedCluster && !isEmpty(selectedCluster) ? Object.values(selectedCluster)?.flat()?.length + (selectedLayer === 'Incidents' ? ' ' + t('Incidents') : ' ' + t('Services')) : ''}
                    onClose={onCloseDrawer}
                    open={openDrawer}
                    size={!selectedPOI ? null : 'large'}
                    getContainer={() => document.getElementById('drawer-container')}
                    mask={false}
                    // extra={} //For extra buttons in title area
                    className={!selectedPOI ? "my-drawer drawerStyle" : 'drawerStyle'}
                >
                    {!selectedPOI ?
                        <RegisterDetailClusterView selectedCluster={selectedCluster} setSelectedPOI={(value) => setSelectedPOI(value)} selectedLayer={selectedLayer} />
                        : <RegisterDetailView selectedPOI={selectedPOI} setCreateIncidentModal={setCreateIncidentModal} />
                    }
                </Drawer>
            </DrawerContainer>

            {/* <MapCreateIncidentModal
                selectedPOI={selectedPOI}
                isCreateIncidentModalOpen={createIncidentModal}
                setCreateIncidentModal={setCreateIncidentModal}
                mapClickCoordinates={{ lat: selectedPOI?.latitude, lng: selectedPOI?.longitude }} /> */}
        </>
    )
}

export default MapDrawer;